import PropTypes from 'prop-types';
import { Picture } from '@bwoty-web/styleguide';
import { getImageSources } from './mapNuggetSrc';
import './mapNugget.scss';

const MapNugget = ({ labels, imageDomain, onClick }) => {
  if (!labels?.mapImage?.image) {
    return null;
  }

  const { mediaUrl, focalPoint } = labels.mapImage.image;

  return (
    <button type="button" className="gw-hotel-map-nugget" onClick={onClick}>
      <Picture
        sources={getImageSources(mediaUrl, imageDomain, focalPoint)}
        alt=""
      />
    </button>
  );
};

MapNugget.propTypes = {
  labels: PropTypes.shape({
    mapImage: PropTypes.shape({
      image: PropTypes.shape({
        mediaUrl: PropTypes.string,
        focalPoint: PropTypes.shape({}),
      }),
    }),
  }).isRequired,
  imageDomain: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default MapNugget;
